var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makePersistent } from '../persistent/makePersistent';
import { getArtifactId } from '../utils';
import { getSchema } from '../schema/getSchema';
import { SchemaModel } from './SchemaModel';
import { ManagedStorage } from '../persistent/ManagedStorage';
import { loadBundle } from './utils/loadBundle';
var DebugPanel = /** @class */ (function () {
    function DebugPanel(settings, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.settings = settings;
        this.cleanupFunctions = [];
        this.keyboardListener = function (event) {
            // Ctrl + Alt + Shift + L
            if (event.keyCode === 76 &&
                event.altKey &&
                event.ctrlKey &&
                event.shiftKey) {
                if (!_this.opened) {
                    _this.open();
                }
                else {
                    _this.close();
                }
            }
            // Esc
            if (_this.opened &&
                event.keyCode === 27 &&
                !event.altKey &&
                !event.ctrlKey &&
                !event.shiftKey) {
                return _this.close();
            }
        };
        this.options = __assign(__assign({ showGeneralInfo: true, version: window.__CI_APP_VERSION__ }, options), { schema: new SchemaModel(options.schema ? options.schema : getSchema(settings) || {}) });
        this.state = this.createState();
    }
    Object.defineProperty(DebugPanel.prototype, "opened", {
        get: function () {
            return this.state.opened;
        },
        set: function (value) {
            this.state.opened = value;
        },
        enumerable: false,
        configurable: true
    });
    DebugPanel.prototype.start = function () {
        var _this = this;
        window.addEventListener('keydown', this.keyboardListener);
        this.cleanupFunctions.push(function () {
            window.removeEventListener('keydown', _this.keyboardListener);
        });
        if (this.opened) {
            this.open(true);
        }
    };
    DebugPanel.prototype.open = function (isRestored) {
        if (isRestored === void 0) { isRestored = false; }
        return __awaiter(this, void 0, void 0, function () {
            var panel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.opened && !isRestored) {
                            return [2 /*return*/];
                        }
                        this.opened = true;
                        return [4 /*yield*/, this.getPanel()];
                    case 1:
                        panel = _a.sent();
                        return [4 /*yield*/, panel.open(isRestored)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DebugPanel.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.panel) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.panel.close()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.opened = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DebugPanel.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.panel) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.panel.destroy()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.cleanupFunctions.forEach(function (fn) { return fn(); });
                        return [2 /*return*/];
                }
            });
        });
    };
    DebugPanel.prototype.getPanel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var module_1, DefaultPanelCls;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.panel) return [3 /*break*/, 2];
                        return [4 /*yield*/, loadBundle('DefaultPanel')];
                    case 1:
                        module_1 = _a.sent();
                        DefaultPanelCls = module_1.DefaultPanel;
                        this.panel = new DefaultPanelCls({
                            settings: this.settings,
                            options: this.options,
                            onClose: function () { return _this.close(); },
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.panel];
                }
            });
        });
    };
    DebugPanel.prototype.createState = function () {
        var options = {
            opened: false,
        };
        var artifactId = getArtifactId();
        return makePersistent(options, new ManagedStorage(artifactId + ".DebugPanelState"));
    };
    return DebugPanel;
}());
export { DebugPanel };
function appendScript(src) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.onload = function () { return resolve(); };
        script.onerror = function () { return reject(new Error("Could not load " + src)); };
        script.src = src;
        document.head.appendChild(script);
    });
}
//# sourceMappingURL=DebugPanel.js.map